import { Component, ChangeDetectorRef } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

export interface ReminderDialogResult {
  reminderTime: string; // ISO datetime
  reminderDate: Date;
  cleared?: boolean;
}

@Component({
  selector: 'app-reminder-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule
],
  templateUrl: './reminder-dialog.component.html',
  styleUrls: ['./reminder-dialog.component.scss'],
})
export class ReminderDialogComponent {
  reminderDate: Date | null = null;
  selectedTime = '09:00';
  timeSlots: string[] = [];

  ngOnInit(): void {
    this.timeSlots = this.generateTimeSlots();
  }

  private generateTimeSlots(): string[] {
    const slots: string[] = [];
    for (let h = 7; h <= 19; h++) {
      for (let m = 0; m < 60; m += 15) {
        slots.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
      }
    }
    return slots;
  }

  constructor(
    private dialogRef: MatDialogRef<ReminderDialogComponent>,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
  ) {}

  setQuickReminder(option: string): void {
    const now = new Date();
    let target: Date;

    switch (option) {
      case '1hour':
        target = new Date(now.getTime() + 60 * 60 * 1000);
        break;
      case 'tomorrow9':
        target = new Date(now);
        target.setDate(target.getDate() + 1);
        target.setHours(9, 0, 0, 0);
        break;
      case '2days':
        target = new Date(now);
        target.setDate(target.getDate() + 2);
        target.setHours(9, 0, 0, 0);
        break;
      case 'nextmonday':
        target = new Date(now);
        const day = target.getDay();
        const diff = day === 0 ? 1 : 8 - day;
        target.setDate(target.getDate() + diff);
        target.setHours(9, 0, 0, 0);
        break;
      default:
        return;
    }

    this.reminderDate = target;
    // Kerekítés a legközelebbi 15 percre (felfelé)
    const mins = target.getMinutes();
    const roundedMins = Math.ceil(mins / 15) * 15;
    const h = roundedMins === 60 ? target.getHours() + 1 : target.getHours();
    const m = roundedMins === 60 ? 0 : roundedMins;
    this.selectedTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    this.cdr.detectChanges();
  }

  clearReminder(): void {
    this.reminderDate = null;
    this.selectedTime = '09:00';
    this.cdr.detectChanges();
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onClear(): void {
    this.snackBar.open('Emlékeztető törölve', 'OK', { duration: 3000 });
    this.dialogRef.close({ cleared: true } as any);
  }

  onSave(): void {
    if (!this.reminderDate) return;
    const [h, m] = this.selectedTime.split(':').map(Number);
    const d = new Date(this.reminderDate);
    d.setHours(h, m, 0, 0);
    // Lokális idő formázása UTC konverzió nélkül
    const localISO = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}T${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:00`;
    this.dialogRef.close({
      reminderTime: localISO,
      reminderDate: d,
    } as ReminderDialogResult);
  }
}
